import { render } from "./Index.vue?vue&type=template&id=527fbd1e"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

const cssModules = script.__cssModules = {}
import style0 from "./Index.vue?vue&type=style&index=0&id=527fbd1e&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script